<template>
  <div class="emptyStatediv">
    <div class="emptyStateWrap">
      <template v-if="!useWithoutVHtml">
        <h2 class="emptyStateTitle">{{ title }}</h2>
        <p class="emptyStateDescription" v-html="description" />
      </template>
      <template v-if="useWithoutVHtml">
        <h2 class="emptyStateTitle">{{ title }}</h2>
        <p class="emptyStateText">{{ description }}</p>
      </template>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "VEmptyState",
  props: {
    title: {
      type: String,
      default: "You don't have access to this issue",
    },
    description: {
      type: String,
      default:
        "Make sure the issue exists in this project. If it does, ask a project admin for permission to see the project's issues.",
    },
    useWithoutVHtml: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.emptyStateTitle {
  font-size: var(--font-size-300);
  padding: 0.5rem;
}
.emptyStateDescription {
  font-size: var(--font-size-100);
  text-align: justify;
}
.emptyStateText {
  font-size: var(--font-size-50);
  margin: 0;
  padding: 0.5rem;
}
.emptyStatediv {
  font-family: var(--font-system-ui);
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
}
.emptyStateWrap {
  width: 60%;
  gap: 2em;
  margin: 2rem 0;
  padding: 0.5rem;
  background-color: var(--gray-200);
  border: 1px solid;
  text-align: center;
}
</style>
